import BaseSetup from '@/components/BaseSetup';
import { ORDER_STATUS } from '@/typings/enums/ORDER_STATUS';
import { Reactive } from '@/utils/decorators';
import { Bus, useTour } from '@orion.ui/orion';
import { nextTick, ref } from 'vue';

export type TourOrderDetailsAgencyEmits = {};
export type TourOrderDetailsAgencyProps = {};

export default class TourOrderDetailsAgencySetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourOrderDetailsAgency = ref<OrionTour>();

	@Reactive private readonly state = {
		canCancel: false,
		canValidate: false,
		canUpdate: true,
	};

	get canCancel () { return this.state.canCancel }
	get canValidate () { return this.state.canValidate }
	get canUpdate () { return this.state.canUpdate }

	constructor (
		private props: TourOrderDetailsAgencyProps,
		private emits: TourOrderDetailsAgencyEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();

		useTour('tourOrderDetailsAgency', this._tourOrderDetailsAgency.value);

		this.registerBusEvent('tourOrderDetailsAgency', (payload) => {
			nextTick(() => {
				this.state.canCancel = payload.order.status !== ORDER_STATUS.Validated && payload.canUpdate;
				this.state.canValidate = payload.order.status !== ORDER_STATUS.Canceled && payload.order.status !== ORDER_STATUS.Validated && payload.canUpdate;
				this.state.canUpdate = payload.canUpdate;
			});
		});
	}

	openDiscussion () {
		Bus.emit('OrderDetailsSetup:openDiscussion');
		useTour('tourOrderDetailsAgency').stop();
	}

}
